var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonOpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    stroke: "#000",
    strokeWidth: 0.404
  }, /*#__PURE__*/React.createElement("path", {
    id: "top",
    d: "m0.93043 13.364-0.16917-3.045s1.5506-7.5361 10.996-7.6126c9.7533-0.07903 11.419 6.7668 11.419 6.7668l0.25375 3.2142s-1.288 6.3407-11.165 6.4284c-9.5647 0.084907-11.334-5.7517-11.334-5.7517z",
    fill: "#0156cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bottom",
    d: "m23.43 13.026v0.08458l-0.08459 3.2142s-4.1622 5.5539-11.165 5.498c-7.1922-0.057449-11.081-4.9905-11.081-4.9905l-0.16917-2.8759s1.5425 5.5981 10.911 5.6672c10.867 0.08015 11.588-6.5976 11.588-6.5976z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m0.76126 10.319s2.7432 6.6649 10.827 6.4284c9.8996-0.28959 11.673-6.1747 11.673-6.1747l-0.08458 0.08459",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonOpt);
export default __webpack_public_path__ + "static/media/button_opt.9546b4119f359c1734801df78909d300.svg";
export { ForwardRef as ReactComponent };